import React from 'react'
import Box from '@mui/material/Box';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import ThumbDownAltRoundedIcon from '@mui/icons-material/ThumbDownAltRounded';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

function PanelCard({ onClick, title, subtitle, Icon, color, children }) {
    return (
        <Box
            onClick={onClick}
            sx={{
                flex: 1, minWidth: 300,
                p: 2.25, borderRadius: 3,
                bgcolor: '#fff', border: '1px solid #e3e6ea',
                cursor: 'pointer',
                transition: 'transform .18s, box-shadow .18s, border-color .18s',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: `0 12px 24px ${color}1f`,
                    borderColor: `${color}55`,
                    '& .panel-arrow': { opacity: 1, transform: 'translateX(0)' },
                },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{
                        width: 46, height: 46, borderRadius: 2.5,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: `linear-gradient(135deg, ${color} 0%, ${color}b3 100%)`,
                        boxShadow: `0 6px 14px ${color}40`, color: '#fff',
                    }}>
                        <Icon sx={{ fontSize: 24 }} />
                    </Box>
                    <Box>
                        <Box sx={{ fontWeight: 700, fontSize: 16.5, color: '#263238' }}>{title}</Box>
                        <Box sx={{ fontSize: 12.5, color: '#78909c' }}>{subtitle}</Box>
                    </Box>
                </Box>
                <ArrowForwardRoundedIcon className="panel-arrow" sx={{
                    color, opacity: 0, transform: 'translateX(-6px)', transition: 'all .18s', mt: 1,
                }} />
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5, mt: 2, flexWrap: 'wrap' }}>
                {children}
            </Box>
        </Box>
    );
}

function MiniStat({ label, value, Icon, color }) {
    return (
        <Box sx={{
            flex: 1, minWidth: 130,
            display: 'flex', alignItems: 'center', gap: 1.25,
            p: 1.5, borderRadius: 2.5,
            bgcolor: `${color}0d`, border: `1px solid ${color}26`,
        }}>
            <Icon sx={{ fontSize: 22, color }} />
            <Box sx={{ lineHeight: 1.15 }}>
                <Box sx={{ fontSize: 12, color: '#78909c', fontWeight: 600 }}>{label}</Box>
                <Box sx={{ fontSize: 24, fontWeight: 800, color }}>{value}</Box>
            </Box>
        </Box>
    );
}

const CardPorcess = (props) => {

    function isClicklink() {
        if (props.dataStatusType == '100') {
            window.location.href = '/documents'
        } else if (props.dataStatusType != '100') {
            if (props.dataStatusType == "") {
                window.location.reload()
            } else {
                window.location.href = '/approvelist'
            }

        }
    }

    function isClickToLink() {
        window.location.href = '/ViewOnProcess'
    }

    return (
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <PanelCard
                onClick={() => isClicklink()}
                title="Document Reject Process"
                subtitle="Standard document approval workflow"
                Icon={ReportProblemRoundedIcon}
                color="#e53935"
            >
                <MiniStat label="Document Reject" value={props.countReject} Icon={ThumbDownAltRoundedIcon} color="#e53935" />
                <MiniStat label="Edit Reject" value={props.countRejectEdit} Icon={EditNoteRoundedIcon} color="#f4511e" />
            </PanelCard>

            <PanelCard
                onClick={() => isClickToLink()}
                title="Document On Process"
                subtitle="Standard document approval workflow"
                Icon={AutorenewRoundedIcon}
                color="#3949ab"
            >
                <MiniStat label="Document Total All" value={props.journalInPro.length} Icon={AutorenewRoundedIcon} color="#3949ab" />
            </PanelCard>
        </Box>
    )
}

export default CardPorcess
